export * from "./update-dataset-value"
export * from "./with-props-validation"

/**
 * Defer importing a def view function until it's called
 *
 * There are some limitations in webpack around dynamic expressions, and so we
 * need to have the view base be a known path like `../`
 *
 * https://webpack.js.org/guides/migrating/#dynamic-expressions
 *
 * @param {String} path Path to view module (relative to entry root)
 */

function importDeferredView(path) {
  return (el, props) => {
    return import(`../${path}/index.js`).then(f => f.default(el, props))
  }
}

export default {
  lazyLoad: importDeferredView("lazy-load"),
  toggleClass: importDeferredView("toggle-class"),
  benchmarkPercentileChart: importDeferredView("benchmark-percentile-chart"),
  benchmarkMeanChart: importDeferredView("benchmark-mean-chart"),
  benchmarksList: importDeferredView("benchmarks-list"),
  benchmarksSelector: importDeferredView("benchmarks-selector"),
  horizontalDragAndScroll: importDeferredView("horizontal-drag-and-scroll"),
  toggleClass: importDeferredView("toggle-class"),
  navCarousel: importDeferredView("nav-carousel"),
  transparentVideo: importDeferredView("transparent-video"),
}
